import { requestAsync } from 'redux-query';

import endpoints from 'consts/endpoints';

export interface clientAoDataType {
  company_id: string;
  errorCallback?: Function;
  resultKey?: string;
}

export default ({ company_id, errorCallback, resultKey = 'aOByCompanyData' }: clientAoDataType) =>
  requestAsync({
    url: endpoints.getAOByCompanyUrl(company_id),
    transform: (response) => ({
      [resultKey]: response,
    }),
    queryKey: endpoints.getAOByCompanyUrl(company_id),
    options: {
      headers: {
        Accept: 'application/json',
      },
    },
    meta: {
      authToken: true,
      errorCallback,
    },
    update: {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      [resultKey]: (_prevEntities, newEntities) => newEntities,
    },
  });
